<template>
  <div id="mine">
    <div class="mine_main">
      <div class="relativeItem">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xiangshui/xiangshui(7).png"
        />
        <div class="pu_namme absoluteItem flex-box centerImg">
          <p class="me_te">我的</p>
          <div class="my_con" @click="goPu">
            <img
              class="imgBlock noevents-img"
              src="../../assets/xiangshui/xiangshui(16).png"
            />
          </div>
        </div>
        <div class="pu_num absoluteItem flex-box centerImg">
          <p>{{ allEnergy }}</p>
          <p>当前已{{ textCom }}精力值</p>
        </div>
      </div>
      <div class="ctr_list">
        <listCom
          :listData="rankData"
          :textCom="textCom"
          :isAnchor="isAnchor"
          v-if="rankData.length != 0"
        ></listCom>
        <div class="noBg_con" v-else>
          <img class="imgBlock noevents-img" src="../../assets/xiangshui/xiangshui(8).png" />
        </div>
      </div>

      <img
        class="imgBlock noevents-img"
        src="../../assets/xiangshui/xiangshui(10).png"
      />
      <div class="bot_colo"></div>
    </div>
  </div>
</template>









<script>
import listCom from "./listCom";

export default {
  props: ["isAnchor", "allEnergy"],
  components: {
    listCom,
  },
  data() {
    return {
      textCom: "贡献",
      rankData: [],
    };
  },
  mounted() {
    this.$tool.setTitle("闻香识女人");
    this.judeText();
  },
  methods: {
    goPu() {
      this.$emit("myPuChange"); //通知父组件改变。
    },
    judeText() {
      if (this.isAnchor == 2) {
        this.textCom = "贡献";
        this.getMyData("perfume_myAnchorRank");
      } else {
        this.textCom = "收集";
        this.getMyData("perfume_myUserRank");
      }
    },
    getMyData(apiName) {
      let _this = this;
      this.$jsonp(this.$apis(apiName), {}, (res) => {
        _this.rankData = [];
        _this.rankData = res.data.data;
        _this.rankData.forEach((ele) => {
          if (ele.total_energy * 1 > 99999) {
            ele.total_energy = _this.textOverSix(ele.total_energy * 1);
          }
        });
      });
    },

     textOverSix(value) {
      if (value > 99999 && value <= 999999) {
        value = ((value / 1000) / 10).toFixed(2) + "w";
      } else if (value > 999999 && value <= 9999999) {
        value = ((value / 1000) / 10).toFixed(2) + "w";
      } else if(value > 9999999) { 10000000
        value = ((value / 100000) / 100).toFixed(2) + "kw";
      }
      return value;
    },
  },
};
</script>









<style scoped>
#mine {
  width: 100%;
}
.noBg_con {
  padding-top: 10px;
}
.noBg_con img {
  width: 80%;
  margin: 25px auto 0;
}

.ctr_list {
  min-height: 300px;
  background: url("../../assets/xiangshui/xiangshui(15).png") repeat;
  background-size: 100% 100%;
  padding: 0 10% 0;
}
.bot_colo {
  background-color: #9d0208;
  height: 30px;
}
.pu_namme {
  top: 25%;
  width: 70%;
  justify-content: space-between;
}
.my_con img {
  width: 77px;
  height: 21px;
}

.pu_num {
  top: 58%;
  width: 70%;
  height: 30px;
  justify-content: space-between;
  align-items: center;
}
.pu_num p:nth-child(1) {
  font-size: 1.875rem;
  color: rgb(51, 51, 51);
}
.pu_num p:nth-child(2) {
  font-size: 0.875rem;
  color: #403e3e;
}
.me_te {
  color: #ff7776;
  font-weight: bold;
  font-size: 18px;
}
</style>